import { Link } from "react-router-dom";
import { ArrowLeft } from "lucide-react";
import { AnimatedWords } from "@/components/motion";

export default function PageHero({ eyebrow, title, accent, subtitle }) {
  return (
    <header className="relative overflow-hidden border-b border-white/10 bg-[#0A0A0A] pt-36 pb-16 md:pt-44 md:pb-20">
      <div className="pointer-events-none absolute -right-10 top-24 select-none opacity-[0.04]">
        <span className="font-display text-[22vw] leading-none uppercase">TRAINOVA</span>
      </div>
      <div className="relative z-10 mx-auto max-w-[1100px] px-6 md:px-12">
        <Link
          to="/"
          data-testid="page-back-home"
          className="mb-8 inline-flex items-center gap-2 text-sm uppercase tracking-widest text-zinc-400 transition-colors duration-200 hover:text-teal"
        >
          <ArrowLeft size={16} /> Back to home
        </Link>
        <div className="mb-4 flex items-center gap-3">
          <span className="h-px w-10 bg-teal" />
          <span className="font-condensed text-base tracking-[0.35em] text-teal">{eyebrow}</span>
        </div>
        <h1 className="font-display text-5xl leading-[0.9] uppercase sm:text-6xl md:text-7xl">
          <AnimatedWords text={title} />{" "}
          {accent && (
            <span className="accent-teal">
              <AnimatedWords text={accent} delay={0.15} />
            </span>
          )}
        </h1>
        {subtitle && <p className="mt-6 max-w-2xl text-base text-zinc-400 md:text-lg">{subtitle}</p>}
      </div>
    </header>
  );
}
